<div class="modal-header">
    <h4 class="modal-title pull-left" translate>Advanced search</h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="modalRef.hide()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div tabindex="-1" class="modal-body" (scroll)="closeOpenedDropdowns()">
    <form #searchForm="ngForm" [ngClass]="{ 'submitted form-submitted': isFormSubmitted }">
        <div class="form-group">
            <label for="authorInput" translate>Author name, email, phone number</label>
            <input
                type="text"
                class="form-control"
                id="authorInput"
                appFocus
                [appAutoFocus]="true"
                maxlength="100"
                placeholder="{{ 'Author name, email, phone number' | translate }}"
                [(ngModel)]="searchModel.usersQuery"
                name="usersQuery"
                ngControl="usersQuery" />
        </div>
        <div class="d-flex flex-row">
            <div class="form-group flex-fill me-1">
                <label for="threadContainsInput" translate>Thread contains</label>
                <input
                    type="text"
                    class="form-control"
                    id="threadContainsInput"
                    clean-field
                    maxlength="100"
                    placeholder="{{ 'Thread contains' | translate }}"
                    [(ngModel)]="searchModel.threadQuery"
                    name="threadQuery" />
            </div>
            <div class="form-group flex-fill ms-1">
                <label for="fieldValuesInput" translate>Fields values</label>
                <input
                    type="text"
                    class="form-control"
                    id="fieldValuesInput"
                    clean-field
                    maxlength="100"
                    placeholder="{{ 'Fields values' | translate }}"
                    [(ngModel)]="searchModel.fieldsQuery"
                    name="fieldsQuery" />
            </div>
        </div>
        <hr />
        <div class="d-flex flex-row">
            <div class="form-group flex-fill me-1">
                <label for="fromDate" translate>From date</label>
                <input
                    type="text"
                    placeholder="{{ 'From date' | translate }}"
                    class="form-control"
                    bsDatepicker
                    autocomplete="off"
                    #datepicker="bsDatepicker"
                    [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false }"
                    [(ngModel)]="searchModel.fromDate"
                    name="fromDate"
                    id="fromDate" />
            </div>
            <div class="form-group flex-fill ms-1">
                <label for="toDate" translate>To date</label>
                <input
                    type="text"
                    placeholder="{{ 'To date' | translate }}"
                    class="form-control"
                    bsDatepicker
                    autocomplete="off"
                    [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false }"
                    #datepicker="bsDatepicker"
                    [(ngModel)]="searchModel.toDate"
                    name="toDate"
                    id="toDate" />
            </div>
        </div>
        <div class="form-group">
            <label for="status" translate (click)="statusNgSelect.open()">Status</label>
            <ng-select
                #statusSelect
                [searchable]="false"
                [clearable]="false"
                class="select-control"
                [(ngModel)]="searchModel.status"
                id="status"
                name="status">
                @for (status of ticketStatusEnum | enumToArray; track status) {
                    <ng-option [value]="status">
                        {{ status | ticketStatus }}
                    </ng-option>
                }
            </ng-select>
        </div>

        <div class="d-flex flex-row">
            <div class="form-group flex-fill w-50">
                <label for="folder" translate (click)="folderNgSelect.open()">Folder</label>
                <ng-select
                    #folderSelect
                    [searchable]="false"
                    [clearable]="false"
                    class="select-control"
                    [(ngModel)]="searchModel.folder"
                    id="folder"
                    name="folder"
                    (ngModelChange)="cleanDependedFolderValues('closedBy')">
                    <ng-option [value]="ticketFolderEnum.notArchived">
                        <span translate>All</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.closedByAgent">
                        <span translate>Closed by agent</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.closedByGroup">
                        <span translate>Closed by group</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.expired">
                        <span translate>Expired</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.sharedAccess">
                        <span translate>Shared access</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.answeredByMe">
                        <span translate>Answered by me</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.spam">
                        <span translate>Spam</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.draft">
                        <span translate>Draft</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.assignedToMe">
                        <span translate>Assigned to me</span>
                    </ng-option>
                    <ng-option [value]="ticketFolderEnum.reminders">
                        <span translate>Reminders</span>
                    </ng-option>
                </ng-select>
            </div>

            @if (searchModel.folder === ticketFolderEnum.closedByGroup) {
                <div class="form-group flex-fill ms-2 w-50">
                    <label for="groupName" translate (click)="groupNgSelect.open()">Group</label>
                    <ng-select
                        #groupSelect
                        [searchable]="false"
                        [clearable]="false"
                        class="select-control"
                        [(ngModel)]="searchModel.closedByAnyAgentFromGroup"
                        id="groupName"
                        name="groupName"
                        placeholder="Choose group"
                        [required]="isFormSubmitted">
                        @for (group of userGroups; track group.id) {
                            <ng-option [value]="group.id">
                                {{ group.name }}
                            </ng-option>
                        }
                    </ng-select>
                </div>
            }

            @if (searchModel.folder === ticketFolderEnum.closedByAgent) {
                <div class="form-group flex-fill ms-2 w-50">
                    <label class="label-as-container">
                        <span class="label-value" translate>Agent</span>
                        <app-tags-input
                            [selectedItems]="closedByUsers"
                            [items]="users"
                            displayBy="label"
                            [contentType]="'users'"
                            [maxItems]="1"
                            placeholder="{{ 'Select users' | translate }}">
                        </app-tags-input>
                    </label>
                </div>
            }
        </div>

        <div class="form-group">
            <label class="label-as-container">
                <span class="label-value" translate (click)="sentimentNgSelect.open()">Sentiment</span>
                <ng-select
                    #sentimentSelect
                    [searchable]="false"
                    [clearable]="false"
                    class="select-control"
                    [(ngModel)]="searchModel.sentiment"
                    name="sentiment">
                    @for (sentiment of sentimentEnum | enumToArray; track sentiment) {
                        <ng-option [value]="sentiment">
                            {{ sentiment | sentiment }}
                        </ng-option>
                    }
                </ng-select>
            </label>
        </div>

        <div class="d-flex flex-row">
            <div class="form-group flex-fill w-50">
                <label for="source" translate (click)="sourceNgSelect.open()">Source</label>
                <ng-select
                    #sourceSelect
                    [searchable]="false"
                    [clearable]="false"
                    class="select-control"
                    [(ngModel)]="searchModel.source"
                    (ngModelChange)="searchModel.sourceSubtype = 0"
                    id="source"
                    name="source">
                    <ng-option [value]="0">
                        {{ 'All' | translate }}
                    </ng-option>
                    <!--                    todo: check this method availableTicketSubTypes - maybe should be pipe-->
                    @for (source of objectKeys(availableTicketSubTypes); track source) {
                        <ng-option [value]="source">
                            {{ source | ticketSource }}
                        </ng-option>
                    }
                </ng-select>
            </div>
            @if (
                searchModel.source &&
                availableTicketSubTypes[searchModel.source] &&
                availableTicketSubTypes[searchModel.source].length
            ) {
                <div class="form-group flex-fill ms-2 w-50">
                    <label for="social-media-sub-folder" translate (click)="sourceSubtypeNgSelect.open()"
                        >Subtype</label
                    >
                    <ng-select
                        #sourceSubtypeSelect
                        [searchable]="false"
                        [clearable]="false"
                        class="select-control"
                        [(ngModel)]="searchModel.sourceSubtype"
                        id="social-media-sub-folder"
                        name="sourceSubtype">
                        <ng-option [value]="0">
                            {{ 'All' | translate }}
                        </ng-option>
                        @for (subtype of availableTicketSubTypes[searchModel.source]; track subtype) {
                            <ng-option [value]="subtype">
                                {{ subtype | ticketSourceSubtype }}
                            </ng-option>
                        }
                    </ng-select>
                </div>
            }
        </div>

        <div class="d-flex flex-row">
            <div class="form-group me-1">
                <label for="last-update-days-duration" translate>Tickets newer than</label>
                <div
                    class="ms-2 confirmation-access-hint"
                    tooltip="{{
                        'This filter will only show tickets which have been updated within a certain amount of days. Any comment, note, assign activity or similar counts as an update. Just viewing the ticket does not count as update.'
                            | translate
                    }}"
                    container="body">
                    i
                </div>
                <div class="d-flex align-items-end">
                    <input
                        type="number"
                        class="form-control"
                        id="last-update-days-duration"
                        [(ngModel)]="searchModel.lastUpdateDaysDuration"
                        name="lastUpdateDaysDuration"
                        min="1"
                        sbValidIntegerNumber
                        sbValidMin="1"
                        maxlength="100" />
                    <span class="ms-1 me-4" translate>Days</span>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row">
            <div class="form-group flex-fill w-50">
                <label for="assign-status" translate (click)="assignStatusNgStatus.open()">Assign status</label>
                <ng-select
                    #assignStatusSelect
                    [searchable]="false"
                    [clearable]="false"
                    class="select-control"
                    id="assign-status"
                    name="assignStatus"
                    [(ngModel)]="searchModel.isAssigned"
                    (ngModelChange)="cleanDependedFolderValues('assignees')">
                    @for (assignStatus of ticketAssignStatusEnum | enumToArray; track assignStatus) {
                        <ng-option [value]="assignStatus">
                            {{ assignStatus | assignStatus }}
                        </ng-option>
                    }
                </ng-select>
            </div>

            @if (searchModel.isAssigned === ticketAssignStatusEnum.assigned) {
                <div class="form-group ms-2 w-50">
                    <label class="label-as-container">
                        <span class="label-value" translate>Assigned to:</span>
                        @if (users.length > 0) {
                            <app-tags-input
                                [selectedItems]="assignedUsers"
                                [items]="users"
                                [contentType]="'users'"
                                displayBy="label"
                                placeholder="{{ 'Select user' | translate }}">
                            </app-tags-input>
                        }
                    </label>
                </div>
            }
        </div>

        <app-filters-dropdown (addFilter)="addFilter($event)" [addedFilters]="addedFilters"></app-filters-dropdown>

        @if (addedFilters.fields) {
            @if (!allFields.length) {
                <div class="mb-4" translate>You have no available fields</div>
            } @else {
                @for (searchItem of fieldsSearchItems; track searchItem; let idx = $index) {
                    <div class="d-flex align-items-start">
                        <app-field-search-item [allFields]="allFields" [searchItem]="searchItem" [index]="idx">
                        </app-field-search-item>
                        <button
                            class="btn btn-icon btn-transparent ms-2"
                            (click)="removeFilter('fields', idx)"
                            style="margin-top: 30px">
                            <sb-inline-svg
                                class="icon icon-sm"
                                aria-label="My icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                            </sb-inline-svg>
                        </button>
                    </div>
                }
            }
        }

        @if (addedFilters.attachments) {
            <div class="form-group d-flex align-items-center">
                <label class="checkbox__label checkbox__label--size-small">
                    {{ 'With attachment' | translate }}
                    <input type="checkbox" name="hasAttachments" [(ngModel)]="searchModel.hasAttachments" />
                    <span class="checkbox__checkmark"></span>
                </label>
                <button class="btn btn-icon btn-transparent ms-2" (click)="removeFilter('attachments')">
                    <sb-inline-svg
                        class="icon icon-sm"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </button>
            </div>
        }

        <div class="d-flex flex-row">
            @if (commonDataService.user.hasHelperCategories) {
                <div class="form-group flex-fill me-1 mw-50">
                    <label class="checkbox__label checkbox__label--size-small">
                        {{ 'Only helper tickets' | translate }}
                        <input
                            type="checkbox"
                            name="isOnlyHelperCategories"
                            [(ngModel)]="searchModel.isOnlyHelperCategories"
                            (ngModelChange)="onChangeTicketType($event, 'isOnlyHelperCategories')" />
                        <span class="checkbox__checkmark"></span>
                    </label>
                </div>
            }
            @if (commonDataService.user.isAdmin) {
                <div class="form-group flex-fill me-1 mw-50">
                    <label class="checkbox__label checkbox__label--size-small">
                        {{ 'Only my inbox' | translate }}
                        <input
                            type="checkbox"
                            name="onlyMy"
                            [(ngModel)]="searchModel.onlyMy"
                            (ngModelChange)="onChangeTicketType($event, 'onlyMy')" />
                        <span class="checkbox__checkmark"></span>
                    </label>
                </div>
            }
            @if (commonDataService.customerSettings.isBotEnabled) {
                <div
                    class="form-group flex-fill mw-50"
                    [ngClass]="{
                        'ms-1': commonDataService.user.isAdmin || commonDataService.user.hasHelperCategories,
                    }">
                    <label class="checkbox__label checkbox__label--size-small">
                        {{ 'Only bot tickets' | translate }}
                        <input
                            type="checkbox"
                            name="isAssignedToBot"
                            (ngModelChange)="onChangeTicketType($event, 'isAssignedToBot')"
                            [(ngModel)]="searchModel.isAssignedToBot" />
                        <span class="checkbox__checkmark"></span>
                    </label>
                </div>
            }
        </div>

        <div class="form-group">
            <label class="label-as-container">
                <span class="label-value" translate>Tags</span>
                <app-tags-input
                    [selectedItems]="searchTags"
                    [items]="tagService.allTags"
                    displayBy="text"
                    placeholder="{{ 'Select tags' | translate }}">
                </app-tags-input>
            </label>
        </div>

        <div class="form-group">
            <label translate>Category</label>
            <div class="d-flex align-items-start flex-wrap">
                @if (searchModel.withoutCategory) {
                    <div class="label me-1 truncate mb-1 label-link d-flex align-items-center">
                        <span class="truncate" translate>Uncategorized</span>

                        <sb-inline-svg
                            class="icon icon-close pointer"
                            aria-label="My icon"
                            (click)="searchModel.withoutCategory = !searchModel.withoutCategory"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
                    </div>
                }
                @for (category of selectedCategoriesList; track category; let idx = $index) {
                    <div
                        class="label me-1 truncate mb-1 d-flex align-items-center"
                        container="body"
                        tooltip="{{ 'Category' | translate }}: {{ category | categoryFullName }}">
                        <span class="truncate">{{ category.label }}</span>

                        <sb-inline-svg
                            class="icon icon-close pointer"
                            aria-label="My icon"
                            (click)="removeCategoryFromList(idx)"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
                    </div>
                }
                <button
                    type="button"
                    style="border-radius: 40px; height: 27px"
                    class="btn btn-active"
                    (click)="openCategoriesModal()">
                    {{ '+ Add category' | translate }}
                </button>
            </div>
        </div>

        <div class="form-group w-50">
            <label class="checkbox__label checkbox__label--size-small">
                {{ 'Uncategorized' | translate }}
                <input type="checkbox" name="withoutCategory" [(ngModel)]="searchModel.withoutCategory" />
                <span class="checkbox__checkmark"></span>
            </label>
        </div>

        <hr />

        <div class="form-group">
            <label class="label-as-container">
                <span class="label-value" translate>Replies</span>
                <app-tags-input
                    [selectedItems]="replyBy.selectedUsers"
                    [items]="users"
                    [contentType]="'users'"
                    displayBy="label"
                    placeholder="{{ 'Select users' | translate }}">
                </app-tags-input>
            </label>
        </div>

        <div class="d-flex flex-row">
            <div class="form-group flex-fill me-1">
                <label for="reply-from-date" translate>From date</label>
                <input
                    type="text"
                    placeholder="{{ 'From date' | translate }}"
                    class="form-control"
                    bsDatepicker
                    autocomplete="off"
                    #datepicker="bsDatepicker"
                    [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false }"
                    container="#date-picker-container"
                    [(ngModel)]="searchModel.replyFromDate"
                    name="replyFromDate"
                    id="reply-from-date" />
            </div>
            <div class="form-group flex-fill ms-1">
                <label for="reply-to-date" translate>To date</label>
                <input
                    type="text"
                    placeholder="{{ 'To date' | translate }}"
                    class="form-control"
                    bsDatepicker
                    autocomplete="off"
                    #datepicker="bsDatepicker"
                    [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false }"
                    container="#date-picker-container"
                    [(ngModel)]="searchModel.replyToDate"
                    name="replyToDate"
                    id="reply-to-date" />
            </div>
        </div>

        <div class="form-group flex-fill">
            <label class="checkbox__label checkbox__label--size-small">
                {{ 'No reply from team' | translate }}
                <input type="checkbox" name="hasNoReplyFromTeam" [(ngModel)]="searchModel.hasNoReplyFromTeam" />
                <span class="checkbox__checkmark"></span>
            </label>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-transparent" translate (click)="reset()">Reset filters</button>
    <div>
        <button type="button" class="btn btn-default me-2" (click)="modalRef.hide()" translate>Cancel</button>
        <button type="submit" class="btn btn-primary" (click)="search()" translate>Search</button>
    </div>
</div>
<div id="date-picker-container"></div>
@if (isNeedSecondBackdrop) {
    <bs-modal-backdrop class="modal-backdrop in show"></bs-modal-backdrop>
}
